<template>
    <div class="dropdown" :class="{'show': show}" @click="show = !show" v-click-outside="close">
        <button class="btn dropdown-toggle"
                :class="[`btn-${btnType}`]"
                type="button"
                :id="id"
                data-toggle="dropdown"
                aria-haspopup="true"
                :aria-expanded="show">
            {{ $t(name) }}
        </button>
        <div class="dropdown-menu" :class="{'show': show}" :aria-labelledby="id">
            <a class="dropdown-item pointer" @click="item.action()" v-for="(item, index) in items" :key="index">
                {{ $t(item.name) }}
            </a>
        </div>
    </div>
</template>
<script>

export default {
    name: 'AppDropdown',
    props: {
        id: [String, Number],
        items: Array,
        name: {
            type: String,
            default: 'Dropdown'
        },
        btnType: {
            type: String,
            default: 'primary'
        }
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        close() {
            this.show = false;
        }
    }
};
</script>
